(() => {
  const requested = new WeakSet();

  async function enhance(container) {
    if (requested.has(container) || !container.dataset.relatedUrl || Number(container.dataset.relatedCount) >= 4 || container.dataset.relatedPerformed === 'true') return;
    requested.add(container);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const url = new URL(container.dataset.relatedUrl, window.location.href);
      if (url.origin !== window.location.origin) return;
      const response = await fetch(url.href, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = [...html.querySelectorAll('[data-norea-related]')].find(node => node.dataset.sectionId === container.dataset.sectionId && node.dataset.productId === container.dataset.productId);
      const freshGrid = replacement?.querySelector('[data-norea-related-grid]');
      const currentGrid = container.querySelector('[data-norea-related-grid]');
      if (!container.isConnected || !freshGrid || !currentGrid || Number(replacement.dataset.relatedCount) <= Number(container.dataset.relatedCount)) return;
      currentGrid.replaceChildren(...freshGrid.children);
      currentGrid.hidden = false;
      container.dataset.relatedCount = replacement.dataset.relatedCount;
      container.dataset.relatedPerformed = 'true';
    } catch {
      return;
    } finally {
      clearTimeout(timeout);
    }
  }

  function initialize(root = document) {
    const containers = [...root.querySelectorAll('[data-norea-related]')];
    if (root.matches?.('[data-norea-related]')) containers.unshift(root);
    for (const container of containers) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            enhance(container);
          }
        }, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(container);
      } else {
        enhance(container);
      }
    }
  }

  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
